import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Column from '../core/Column';
import Row from '../core/Row';
import EditNoteIcon from '@mui/icons-material/EditNote';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import RecyclingIcon from '@mui/icons-material/Recycling';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { CopyIcon, Cross, DeleteIcon, EditIcon, TrashCan } from '../icons';
import DelteIcon from '../../../assets/public/icons/delete-icon.gif';
import NoticeModal from '../components/NoticeModal/NoticeModal';
import '../styles/_table_item.scss';
import Title from '../core/Title';
import { getNonce } from '../Helpers';
import Modal from './../core/Modal';

function TableItem({ table, setCopiedTables, setTableCount, setTables, setLoader }) {
	const confirmDeleteRef = useRef();
	const [copySuccess, setCopySuccess] = useState(false);
	const [deleteModal, setDeleteModal] = useState<boolean>(false);

	const [modalConfig, setModalConfig] = useState({
		isOpen: false,
		type: 'confirmation',
		title: '',
		message: '',
		onConfirm: () => { },
		confirmText: 'Confirm',
		declineText: 'Cancel',
		mode: 'success'
	});

	const closeModal = () => {
		setModalConfig(prev => ({ ...prev, isOpen: false }));
	};

	/**
	 * Export form as JSON
	 */
	const handleExportForm = () => {
		wp.ajax.send('simpleform_export_form', {
			data: {
				nonce: getNonce(),
				form_id: table.id,
			},
			success(response) {
				const { export_data, filename } = response;
				
				// Create and download JSON file
				const dataStr = JSON.stringify(export_data, null, 2);
				const dataBlob = new Blob([dataStr], { type: 'application/json' });
				const url = URL.createObjectURL(dataBlob);
				
				const link = document.createElement('a');
				link.href = url;
				link.download = filename;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				URL.revokeObjectURL(url);

				setModalConfig({
					isOpen: true,
					type: 'toast',
					title: 'Success!',
					message: 'Form exported successfully.',
					position: 'top-right',
					mode: 'success',
				});
				setTimeout(closeModal, 3000);
			},
			error(error) {
				console.error(error);
				setModalConfig({
					isOpen: true,
					type: 'toast',
					title: 'Error!',
					message: 'Failed to export form.',
					position: 'top-right',
					mode: 'error',
				});
				setTimeout(closeModal, 3000);
			},
		});
	};

	/**
	 * Clone form
	 */
	const handleCloneForm = () => {
		wp.ajax.send('simpleform_clone_form', {
			data: {
				nonce: getNonce(),
				form_id: table.id,
			},
			success(response) {
				setModalConfig({
					isOpen: true,
					type: 'toast',
					title: 'Success!',
					message: 'Form cloned successfully.',
					position: 'top-right',
					mode: 'success',
				});
				setTimeout(closeModal, 3000);

				// Refresh the forms list
				setLoader(true);
				wp.ajax.send('simpleform_get_tables', {
					data: {
						nonce: getNonce(),
					},
					success({ tables, tables_count }) {
						setTables(tables);
						setCopiedTables(tables);
						setTableCount(tables_count);
						setLoader(false);
					},
					error(error) {
						console.error(error);
						setLoader(false);
					},
				});
			},
			error(error) {
				console.error(error);
				setModalConfig({
					isOpen: true,
					type: 'toast',
					title: 'Error!',
					message: 'Failed to clone form.',
					position: 'top-right',
					mode: 'error',
				});
				setTimeout(closeModal, 3000);
			},
		});
	};

	/**
	 * 
	 * @param id Copy Shortcode
	 */

	const handleCopyShortcode = async (id) => {
		const shortcode = `[simple_form id="${id}"]`;

		try {
			// Check if clipboard API is supported
			if (navigator.clipboard && navigator.clipboard.writeText) {
				await navigator.clipboard.writeText(shortcode);
			} else {
				// Fallback to using a textarea if clipboard API fails
				const textarea = document.createElement('textarea');
				textarea.value = shortcode;
				document.body.appendChild(textarea);
				textarea.select();
				document.execCommand('copy'); // Old method, still works as fallback
				document.body.removeChild(textarea);
			}

			setCopySuccess(true);
			setModalConfig({
				isOpen: true,
				type: 'toast',
				title: 'Copied!',
				message: 'Shortcode has been copied.',
				position: 'top-right',
				mode: 'success',
			});
			setTimeout(closeModal, 400);

			// Reset copySuccess state after 1 second
			setTimeout(() => {
				setCopySuccess(false);
			}, 1000);

		} catch (err) {
			setCopySuccess(false);
			setModalConfig({
				isOpen: true,
				type: 'toast',
				title: 'Failed!',
				message: 'Shortcode copy failed.',
				position: 'top-right',
				mode: 'error',
			});
			setTimeout(closeModal, 400);
		}
	};



	/**
	 * Delete Modal close
	*/
	const handleClosePopup = () => {
		setDeleteModal(false);
	};

	/**
	 * Delete Modal
	*/
	const handleDeleteTable = () => {
		setDeleteModal(true);
	};

	/**
	 * Delete Modal close get confitmation and delete from DB
	*/
	const ConfirmDeleteTable = (id) => {
		wp.ajax.send('simpleform_delete_table', {
			data: {
				nonce: getNonce(),
				id,
			},
			success() {
				// console.log("Form has been deleted")
				setModalConfig({
					isOpen: true,
					type: 'toast',
					title: 'Delete!',
					message: 'Form has been deleted!.',
					position: 'top-right',
					mode: 'success',
				});
				setTimeout(closeModal, 3000);

				setDeleteModal(false);
				setLoader(true);

				wp.ajax.send('simpleform_get_tables', {
					data: {
						nonce: getNonce(),
					},
					success({ tables, tables_count }) {
						// console.log("Form has been deleted 2")
						setTables(tables);
						setCopiedTables(tables);
						setTableCount(tables_count);
						setLoader(false);
					},
					error(error) {
						console.error(error);
					},
				});
			},
			error(error) {
				console.error(error);
			},
		});
	};

	/**
	 * Alert close if clicked on outside of element
	 *
	 * @param  event
	 */
	function handleCancelOutside(event: MouseEvent) {
		if (
			confirmDeleteRef.current &&
			!confirmDeleteRef.current.contains(event.target)
		) {
			handleClosePopup();
		}
	}

	useEffect(() => {
		document.addEventListener('mousedown', handleCancelOutside);
		return () => {
			document.removeEventListener('mousedown', handleCancelOutside);
		};
	}, [handleCancelOutside]);


	const dateTime = new Date(table.time);
	const date = dateTime.toLocaleDateString();
	const time = dateTime.toLocaleTimeString();
	// Define options for formatting the date
	const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
	// Format the date with options
	const formattedDate = dateTime.toLocaleDateString(undefined, options);



	return (
		<div className="modern-table-item">
			{deleteModal && (
				<Modal>
					<div
						className="modern-delete-modal"
						ref={confirmDeleteRef}
					>
						<div className="modal-header">
							<button
								className="close-btn"
								onClick={() => handleClosePopup()}
							>
								<HighlightOffIcon />
							</button>
						</div>
						<div className="modal-body">
							<div className="modal-icon">
								<img 
									className='delete-icon' 
									src={DelteIcon} 
									alt="delete-icon" 
									title="Delete Form"
								/>
							</div>
							<h2>Delete Form</h2>
							<p>Are you sure you want to delete this form? This action cannot be undone.</p>
							<div className="modal-actions">
								<button
									className="cancel-btn"
									onClick={handleClosePopup}
								>
									Cancel
								</button>
								<button
									className="delete-btn"
									onClick={() => ConfirmDeleteTable(table.id)}
								>
									Delete Form
								</button>
							</div>
						</div>
					</div>
				</Modal>
			)}

			<div className="vertical-form-card">
				<div className="form-main-content">
					<div className="form-info-section">
						<Link to={`/edit/${table.id}`} className="form-title-link">
							<h3 className="form-title">{table.form_name}</h3>
						</Link>
						<div className="form-meta">
							<span className="form-id">ID: {table.id}</span>
							<span className="form-date">{formattedDate}</span>
							<span className="form-time">{time}</span>
						</div>
					</div>

					<div className="form-shortcode-section">
						<button
							title='Click to Copy Shortcode'
							className={`shortcode-display ${copySuccess ? 'copied' : ''}`}
							onClick={() => handleCopyShortcode(table.id)}
						>
							<code>[simple_form id="{table.id}"]</code>
							<FileCopyIcon className="copy-icon" />
						</button>
					</div>

					<div className="form-status-section">
						<div className="status-badge active">Active</div>
					</div>
				</div>

				<div className="form-actions-section">
					<Link
						to={`/edit/${table.id}`}
						className="action-btn edit-btn"
						title='Edit Form'
					>
						<EditNoteIcon />
						<span>Edit</span>
					</Link>
					
					<button
						title='Clone Form'
						className="action-btn clone-btn"
						onClick={handleCloneForm}
					>
						<FileCopyIcon />
						<span>Clone</span>
					</button>

					<button
						title='Export Form'
						className="action-btn export-btn"
						onClick={handleExportForm}
					>
						<FileDownloadIcon />
						<span>Export</span>
					</button>
					
					<button
						className="action-btn delete-btn"
						onClick={handleDeleteTable}
						title='Delete Form'
					>
						<DeleteOutlineIcon />
						<span>Delete</span>
					</button>
				</div>
			</div>

			<NoticeModal
				isOpen={modalConfig.isOpen}
				onClose={closeModal}
				onConfirm={modalConfig.onConfirm}
				onDecline={closeModal}
				type={modalConfig.type}
				mode={modalConfig.mode}
				title={modalConfig.title}
				message={modalConfig.message}
				confirmText={modalConfig.confirmText}
				declineText={modalConfig.declineText}
				position={modalConfig.position || 'center'}
				autoClose={modalConfig.type === 'toast'}
				autoCloseTime={3000}
			/>
		</div>
	);
}

export default TableItem;
